export class ApiInformationModel {
  name!: string
  version!: string
}
